import { render } from "./clothes.vue?vue&type=template&id=6cbdd41a&scoped=true"
import script from "./clothes.vue?vue&type=script&lang=js"
export * from "./clothes.vue?vue&type=script&lang=js"

import "./clothes.vue?vue&type=style&index=0&id=6cbdd41a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbdd41a"]])

export default __exports__